import { Collapse, Typography } from "antd";
import classNames from "classnames";
import Markdown from "react-markdown";
import styles from "./MessageBlock.module.css";

const { Text } = Typography;

const MessageBlock = ({ block }) => {
    switch (block.block_type) {
        case "text":
            return (
                <div className={styles.textBlock}>
                    <Markdown>{block.text}</Markdown>
                </div>
            );

        case "user_input_response":
            return (
                <div className={styles.responseBlock}>
                    <Text className={styles.responseLabel}>Selected</Text>
                    <div className={styles.pillContainer}>
                        {block.text.map((pill, i) => (
                            <span key={i} className={styles.historyPill}>
                                {pill}
                            </span>
                        ))}
                    </div>
                </div>
            );

        case "request_user_input": {
            const collapseItems = [
                {
                    key: "1",
                    label: <Text type="secondary" italic className={styles.collapseLabel}>{block.question}</Text>,
                    children: (
                        <div className={styles.optionsGrid}>
                            {block.options.map(option => (
                                <button
                                    key={option.option_id}
                                    disabled
                                    className={classNames(styles.optionButton, styles.inactiveOption, {
                                        [styles.multiOption]: block.input_type === "multiselect",
                                        [styles.singleOption]: block.input_type !== "multiselect",
                                    })}
                                >
                                    <span className={styles.optionText}>{option.text}</span>
                                </button>
                            ))}
                        </div>
                    ),
                },
            ];

            return (
                <div className={styles.historyRequestBlock}>
                    <Collapse
                        ghost
                        className={styles.historyCollapse}
                        expandIconPosition="end"
                        items={collapseItems}
                    />
                </div>
            );
        }

        default:
            return null;
    }
};

export default MessageBlock;